<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // STYLING
    import 'tailwindcss/tailwind.css';

    // CASSIOPEIA
    import {
        Button,
        Heading,
        Card,
        Paragraph,
        Badge,
    } from '@smatch/cassiopeia-web-components';

    // Plugins
    import { t } from 'svelte-i18n';

</script>

<Card css = 'flex flex-col lg:flex-row gap-6 max-w-[560px] mx-auto my-20'>

    <img src = 'https://cdn.smatch.com/assets/image.png'
        alt = ''
        class = 'w-[240px] h-[240px] rounded-lg'
    />

    <div class = 's8-text'>

        <Badge label = { $t('component.auction.list.no_results.badge') } />

        <Heading size = 'sm'> { $t('component.auction.list.no_results.heading') }</Heading>
        <Paragraph label = { $t('component.auction.list.no_results.description_top') } />

        <Button
            label = { $t('component.auction.list.no_results.button') }
            url = '#create-subscription'
            color = 'quaternary'
            style = 'solid'
            icon = 'arrowRight'
            align = 'right'
            css = 'mb-5 mt-4'
        />

        <Paragraph label = { $t('component.auction.list.no_results.description_bottom') } color = 'subtle' />

    </div>

</Card>